import { AES, enc } from "crypto-js";

export const encryptAsAES = ({ toEncrypt, key }): string =>
  AES.encrypt(toEncrypt, key).toString();

export const decryptAES = ({ toDecrypt, key }): string => {
  const bytes = AES.decrypt(toDecrypt, key);
  return bytes.toString(enc.Utf8);
};
